export const EMBED_SOURCE = "onlychess-talk";
export const PORTAL_SOURCE = "onlychess-portal";

export const EMBED_PARENT_ORIGINS = [
  "https://nationalrussianchess.ru",
  "https://www.nationalrussianchess.ru",
  "https://onlychess.nationalrussianchess.ru",
] as const;

export interface PortalEmbedMessage {
  source: typeof PORTAL_SOURCE;
  type: "join";
  code?: string;
  displayName?: string;
  gameId?: string;
}

export function isPortalEmbedMessage(value: unknown): value is PortalEmbedMessage {
  if (!value || typeof value !== "object") return false;
  const message = value as Partial<PortalEmbedMessage>;
  return message.source === PORTAL_SOURCE && message.type === "join";
}

export function postEmbed(message: Record<string, unknown>): void {
  if (typeof window === "undefined" || window.parent === window) return;
  let targetOrigin = "*";
  try {
    const parentOrigin = document.referrer ? new URL(document.referrer).origin : "";
    if ((EMBED_PARENT_ORIGINS as readonly string[]).includes(parentOrigin)) targetOrigin = parentOrigin;
  } catch {
    targetOrigin = "*";
  }
  window.parent.postMessage({ source: EMBED_SOURCE, ...message }, targetOrigin);
}
